import React from "react";

import { Outlet } from "react-router-dom";

import { Spinner } from "src/base-components/Spinner";
import { ErrorPage } from "src/router/ErrorPage";
import { DashboardPageParams } from "src/router/urls";
import { useWorkspaceScoping } from "src/router/useWorkspaceScoping";
import { useParamsDecode } from "src/utils/useParamsDecode";

/**
 * Layout route for workspace routes (`org/:orgId/ws/:wsId/*`). Blocks rendering
 * of the workspace subtree until a token scoped to (orgId, wsId) is in place,
 * so downstream org/workspace guards never observe a token whose scope
 * disagrees with the URL. All scope logic lives in {@link useWorkspaceScoping}.
 */
export const WorkspaceScoping: React.FC = () => {
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();
  const status = useWorkspaceScoping(orgId, wsId);

  if (status === "error") {
    return (
      <ErrorPage message="We couldn't load this workspace. Please try again or contact Taktile support if the problem persists." />
    );
  }

  if (status === "pending") {
    return <Spinner />;
  }

  return <Outlet />;
};
